import { FC } from "react";
import { Card } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { FormCheck } from "go-form";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { useWindowSize } from "go-core/components/useWindowSize";
import FormNumberInput from "go-form/components/FormNumberInput";
import { ReactComponent as RemoveAddonSVG } from "../../../../../../../../images/svg/subscriptions/remove-addon.svg";
import { AddonApi, UpdateSubscriptionsApi } from "../../../../../../../../services/Api/Subscription/subscriptionTypes";
import { PriceConfiguratorAddonApi } from "../../../../../../../../services/Api/types";
import AddonUsageWarning from "./AddonUsageWarning";

interface Props {
	estimateAddon: AddonApi;
	configAddon: PriceConfiguratorAddonApi;
	handleRemove: (addon: AddonApi) => void;
	form: UseFormReturn<UpdateSubscriptionsApi>;
	addonIndex: string;
	index: number;
	monthly?: boolean;
	estimating: boolean;
}

const InstalledAddon: FC<Props> = (props: Props) => {
	const {
		register,
		watch,
		control,
		formState: { errors },
		setValue,
	} = props.form;
	const isSmallBreakpoint = useWindowSize().isSmallBreakpoint;

	const onChange = (val?: number) => {
		if (!val && !props.estimateAddon?.warning && !props.estimating) {
			props.handleRemove(props.estimateAddon);
		}
	};

	if (!props.configAddon) return null;
	if (!props.configAddon || (!props.configAddon.addon_id && !props.configAddon.name)) return null;

	const handleClick = (evt: any) => {
		const val = evt.target.checked ? 1 : 0;
		setValue(`${props.addonIndex}.${props.index}.quantity` as any, val);
		if (val === 0) props.handleRemove(props.estimateAddon);
	};

	const drawContent = () => {
		if (isSmallBreakpoint)
			return (
				<div className={"addon-body"}>
					<div className="addon-body-wrapper">
						<h5>{props.configAddon.name}</h5>
					</div>
					<div className="addon-body-wrapper">
						<div className="d-flex justify-content-between align-items-center w-100">
							<div className="d-flex align-items-center gap-2">
								{(
									props.monthly
										? props.configAddon?.monthly_sub_details.value_type === "NUMBER"
										: props.configAddon?.details.value_type === "NUMBER"
								) ? (
									<FormNumberInput
										onBlur={onChange}
										suffix={""}
										control={control}
										errors={errors}
										name={`${props.addonIndex}.${props.index}.quantity`}
										decimalScale={0}
									/>
								) : (
									<FormCheck
										register={register}
										onClick={handleClick}
										type={"switch"}
										defaultChecked={
											watch(`${props.addonIndex}.${props.index}.quantity` as any) === 1
										}
										name={`${props.addonIndex}.${props.index}.quantity`}
										errors={errors}
									/>
								)}
								<div>{props.estimateAddon ? FormatMoney(props.estimateAddon.total_price) : "~"}</div>
							</div>
							{(props.monthly
								? props.configAddon?.monthly_sub_details.requirement !== "MANDATORY"
								: props.configAddon?.details.requirement !== "MANDATORY") && (
								<RemoveAddonSVG onClick={() => props.handleRemove(props.estimateAddon)} />
							)}
						</div>
						<AddonUsageWarning addon={props.estimateAddon} />
						<div className={"addon-description"}>{props.configAddon.description}</div>
					</div>
				</div>
			);

		return (
			<>
				<div className={"addon-body"}>
					<h5 className={"w-60 addon-body-item"}>{props.configAddon.name}</h5>
					<div className={"w-15 addon-body-item"}>
						{(
							props.monthly
								? props.configAddon?.monthly_sub_details.value_type === "NUMBER"
								: props.configAddon?.details.value_type === "NUMBER"
						) ? (
							<FormNumberInput
								onBlur={onChange}
								suffix={""}
								control={control}
								errors={errors}
								name={`${props.addonIndex}.${props.index}.quantity`}
								decimalScale={0}
							/>
						) : (
							<FormCheck
								register={register}
								onClick={handleClick}
								type={"switch"}
								defaultChecked={watch(`${props.addonIndex}.${props.index}.quantity` as any) === 1}
								name={`${props.addonIndex}.${props.index}.quantity`}
								errors={errors}
							/>
						)}
					</div>
					<div className={"w-15 addon-body-item"}>
						{props.estimateAddon ? FormatMoney(props.estimateAddon.total_price) : "~"}
					</div>
					{(
						props.monthly
							? props.configAddon?.monthly_sub_details.requirement !== "MANDATORY"
							: props.configAddon?.details.requirement !== "MANDATORY"
					) ? (
						<div className={"addon-body-item"}>
							<RemoveAddonSVG onClick={() => props.handleRemove(props.estimateAddon)} />
						</div>
					) : (
						<div className={"addon-body-item"}></div>
					)}
				</div>
				<AddonUsageWarning addon={props.estimateAddon} />
				<div className={"addon-description"}>{props.configAddon.description}</div>
			</>
		);
	};

	return (
		<Card className={"installed-addon"}>
			<Card.Body>{drawContent()}</Card.Body>
		</Card>
	);
};
export default InstalledAddon;
